var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row marketing" }, [
    _c("div", { staticClass: "col-lg-6 offset-3" }, [
      _c("h4", { staticStyle: { "padding-bottom": "20px" } }, [
        _vm._v("\n      Login\n    ")
      ]),
      _vm._v(" "),
      _vm.checkingLogin
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col text-center" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "100",
                    height: "30",
                    viewBox: "0 0 150 50",
                    xmlns: "http://www.w3.org/2000/svg",
                    "attr-fill": "green"
                  }
                },
                [
                  _c("circle", { attrs: { cx: "15", cy: "15", r: "15" } }, [
                    _c("animate", {
                      attrs: {
                        attributeName: "r",
                        from: "15",
                        to: "15",
                        begin: "0s",
                        dur: "0.8s",
                        values: "15;9;15",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                      }
                    }),
                    _vm._v(" "),
                    _c("animate", {
                      attrs: {
                        attributeName: "fill-opacity",
                        from: "1",
                        to: "1",
                        begin: "0s",
                        dur: "0.8s",
                        values: "1;.5;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "circle",
                    {
                      attrs: {
                        cx: "60",
                        cy: "15",
                        r: "9",
                        "fill-opacity": "0.3"
                      }
                    },
                    [
                      _c("animate", {
                        attrs: {
                          attributeName: "r",
                          from: "9",
                          to: "9",
                          begin: "0s",
                          dur: "0.8s",
                          values: "9;15;9",
                          calcMode: "linear",
                          repeatCount: "indefinite"
                        }
                      }),
                      _vm._v(" "),
                      _c("animate", {
                        attrs: {
                          attributeName: "fill-opacity",
                          from: "0.5",
                          to: "0.5",
                          begin: "0s",
                          dur: "0.8s",
                          values: ".5;1;.5",
                          calcMode: "linear",
                          repeatCount: "indefinite"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("circle", { attrs: { cx: "105", cy: "15", r: "15" } }, [
                    _c("animate", {
                      attrs: {
                        attributeName: "r",
                        from: "15",
                        to: "15",
                        begin: "0s",
                        dur: "0.8s",
                        values: "15;9;15",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                      }
                    }),
                    _vm._v(" "),
                    _c("animate", {
                      attrs: {
                        attributeName: "fill-opacity",
                        from: "1",
                        to: "1",
                        begin: "0s",
                        dur: "0.8s",
                        values: "1;.5;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                      }
                    })
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.checkingLogin && !_vm.is3M()
        ? _c(
            "form",
            {
              attrs: { action: "", name: "cform" },
              on: {
                submit: function($event) {
                  return _vm.login()
                }
              }
            },
            [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "exampleInputEmail0" } }, [
                  _vm._v("User Name")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.f.userName,
                      expression: "f.userName"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    id: "exampleInputEmail0",
                    "aria-describedby": "emailHelp",
                    required: "",
                    placeholder: "Enter your UserName"
                  },
                  domProps: { value: _vm.f.userName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.f, "userName", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "exampleInputEmail1" } }, [
                  _vm._v("Password")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.f.password,
                      expression: "f.password"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "password",
                    id: "exampleInputEmail1",
                    "aria-describedby": "emailHelp",
                    required: "",
                    placeholder: "Enter your Password"
                  },
                  domProps: { value: _vm.f.password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.f, "password", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm.loginFailed && !_vm.is3M()
                ? _c("div", { staticClass: "alert alert-danger" }, [
                    _vm._v("Login Failed")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.loginFailed && _vm.is3M()
                ? _c("div", { staticClass: "alert alert-danger" }, [
                    _vm._v("Unable to Login, Contact Administrator")
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.is3M()
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.login()
                        }
                      }
                    },
                    [_vm._v("\n        Login\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.is3M()
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.googleLogin()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fab fa-google-plus-g" }),
                      _vm._v(" Login\n      ")
                    ]
                  )
                : _vm._e()
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef68022e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef68022e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 